import React from 'react';
import '../../styles/layout.css';

export default function RankingList({ items }) {
  if (!items || items.length === 0) {
    return <div className="empty">No utilisation data</div>;
  }

  return (
    <>
      {items.map((r, i) => {
        const col = r.avgHrs >= 8 ? '#16a34a' : r.avgHrs >= 5 ? '#d97706' : '#dc2626';
        return (
          <div className="rank-row" key={r.R}>
            <span className="rank-num">{i + 1}</span>
            <span className="rank-reg">{r.R}</span>
            <span className="rank-type">{r.V}</span>
            <span className="rank-op">{r.O}</span>
            <span className="rank-pct" style={{ color: col }}>{r.avgHrs}h</span>
            <div className="rank-bar">
              <div className="pb">
                <div
                  className="pbf"
                  style={{ width: `${Math.min(r.avgHrs / 16 * 100, 100)}%`, background: col }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
